import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import PersonAdd from "@material-ui/icons/PersonAdd";
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";

import axios from 'axios';
import { API_ROOT, COMPANY_NAME } from 'api-config';
import { getApiHeaders } from '../../assets/helpers/apiHelper.jsx';
import { verifyEmail, verifyPhone } from '../../assets/helpers/formHelper.jsx';

class Invitation extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    var inDialog = false;
    var formControlMargin = 'none'
    var customInputStyle = ''
    if (props.inDialog) {
      inDialog = props.inDialog
      formControlMargin = 'dense'
      customInputStyle = {marginTop: "24px"}
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      userId: sessionStorage.getItem('userId'),
      submitButtonText: 'send invitation',
      invitationTo: '',
      invitationStatus: '',
      invitationStatusIndicator: '',
      inDialog: inDialog,
      formControlMargin: formControlMargin,
      customInputStyle: customInputStyle
    };
  }

  componentDidMount(){
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    //validate fields
    const invitationStatusIndicator = <CircularProgress size={20}/>
    this.setState({
      inputDisabled: true,
      submitButtonText: 'sending',
      invitationStatus: 'sending...',
      invitationStatusIndicator: invitationStatusIndicator
    })
    var invitationStatus = '';
    if (!verifyPhone(this.state.invitationTo) && !verifyEmail(this.state.invitationTo)) {
      invitationStatus = 'Please enter either a valid phone or email.'
    }

    if (invitationStatus) {
      this.setState({
        inputDisabled: false,
        submitButtonText: 'send invitation',
        invitationStatus: invitationStatus,
        invitationStatusIndicator: ''
      })
    } else {

      const invitationData = {
        to: this.state.invitationTo,
        invitationFrom: this.props.invitationFrom
      }
      axios.post(`${API_ROOT}/invitation/`, invitationData, { headers: getApiHeaders() })
        .then(res => this.handleSubmitResponse(res));
    }
  }

  handleSubmitResponse(res) {
    if (this._isMounted) {
      var invitationStatus
      if (res.data.message === 'success') {
        this.setState({
          invitationTo: ''
        })
        invitationStatus = 'We have successfully sent the invitation.'
        if (this.props.onSendReponse) {
          this.props.onSendReponse()
        }
      } else {
        var alertMessage = '';
        if (res.data.error) {
          alertMessage = res.data.error
        } else {
          alertMessage = 'An unknown error occurred.'
        }
        invitationStatus = alertMessage
      }
      this.setState({
        inputDisabled: false,
        submitButtonText: 'send invitation',
        invitationStatus: invitationStatus,
        invitationStatusIndicator: ''
      })
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <form onSubmit={this.handleSubmit}>
        <Card>
          <CardHeader color="cirrusBlue" icon style={this.props.showHeader ? {} : { display: 'none' }}>
            <CardIcon color="cirrusBlue">
              <PersonAdd />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              Invite Patients - <small>invite your patients to {COMPANY_NAME}</small>
            </h4>
          </CardHeader>
          <CardBody>

            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <CustomInput
                  labelText="email or cell phone"
                  type="text"
                  id="invitationTo"
                  formControlProps={{
                    fullWidth: true,
                    margin: this.state.formControlMargin
                  }}
                  inputProps={{
                    onChange: this.handleChange,
                    value: this.state.invitationTo,
                    disabled: this.state.inputDisabled
                  }}
                  customStyle={this.state.customInputStyle}
                />
              </GridItem>
            </GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Button
                round
                onClick={this.handleSubmit}
                color="cirrusBlue"
                disabled={this.state.inputDisabled}
                id="sendInvitationButton"
              >
                {this.state.submitButtonText}
              </Button>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <div id={"invitationStatus"} style={{height: '30px'}} >
                {this.state.invitationStatusIndicator} {this.state.invitationStatus}
              </div>
            </GridItem>
          </CardBody>
        </Card>
      </form>
    )

  }


}

export default withStyles(userProfileStyles)(Invitation);